<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/y2aic0/tc-custom/9781467444095.jpg?1737195126987" alt="This image is the cover for the book The Book of Genesis, The Bible in Medieval Tradition (BMT)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Book of Genesis, The Bible in Medieval Tradition (BMT)
      </h1>
      <p class="bookDescription body article font2">
        <i>Retrieves rich historical biblical insights for readers of Genesis today</i><br/><br/> In this latest addition to the Bible in Medieval Tradition series, Joy Schroeder provides substantial excerpts — none previously available in English — from seven noteworthy medieval biblical interpreters who commented on Genesis between the ninth and fifteenth centuries.<br/><br/> Representing a chronological and geographical range of authors — including Hildegard of Bingen, Nicholas of Lyra, and Denis the Carthusian — these clear, readable translations illustrate the rich diversity of medieval approaches to biblical interpretation. The commentary covers the entire book of Genesis and includes an in-depth introduction by Schroeder that locates each of the medieval authors within his or her context.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joy A. Schroeder
      </h2>
      
      <p class="authorDescription body article">Joy A. Schroeder is professor of church history at Trinity Lutheran Seminary, professor of religion at Capital University, and holder of the Bergener Chair of Theology and Religion at both schools in Columbus, Ohio.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5e18713c